import React from 'react';
import { useI18n } from '@locales/client';
import { useWalletHistory } from '@/features/wallet-managment/model/hooks';

import DownCircle from '@/shared/assets/down-circle.svg';
import { Condition } from '@/shared/ui/condition';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { formatCurrency } from '@/shared/libs/format-currency';
import { Box } from '@/shared/ui/box';
import {
  BodyTextBoldPrimary,
  BodyTextRegularSecondary,
} from '@/shared/ui/typography';

import { PaymentBlock, PaymentIcon } from '@/features/wallet-managment/styles';
import {
  StatusIcon,
  StyledSum,
  AnimatedSpinner,
  TransactionType,
  AddressIcon,
} from './styles';

const History = ({ setCurrentStep, setCurrentTransaction, currencies }) => {
  const t = useI18n();
  const { notifications, user } = useUser();
  const { walletHistory } = useWalletHistory(notifications.transaction);

  return walletHistory?.map((history) => {
    return (
      <Box $paddingBottom={12} key={history?.transactions.at(-1)?.id}>
        <Box $textAlign="left" $marginBottom={8}>
          <BodyTextBoldPrimary>{history.date}</BodyTextBoldPrimary>
        </Box>
        <Box $display="flex" $flexDirection="column" $gap={8}>
          {history.transactions.map((transaction) => {
            const currentCurrency = currencies.find(
              (currency) => currency.code === transaction.transferCurrency
            );
            return (
              <PaymentBlock
                $isFirst={true}
                $isLast={true}
                key={transaction.id}
                onClick={() => {
                  setCurrentTransaction(transaction);
                  setCurrentStep('history-detail');
                }}
              >
                <Box $display="flex" $gap={10} $alignItems="center">
                  <Box $position="relative">
                    <PaymentIcon $gray={true} $type={transaction.type}>
                      <DownCircle />
                    </PaymentIcon>
                    <StatusIcon $status={transaction.status}>
                      {transaction.status === 'pending' && <AnimatedSpinner />}
                      {transaction.status === 'verification' && (
                        <AnimatedSpinner />
                      )}
                    </StatusIcon>
                  </Box>
                  <Box $textAlign="left">
                    <TransactionType>
                      <Condition match={transaction.type === 'deposit'}>
                        {t('wallet.deposit.title')}
                      </Condition>
                      <Condition match={transaction.type === 'withdraw'}>
                        {t('wallet.withdraw.title')}
                      </Condition>
                    </TransactionType>
                    <Box
                      $marginBottom={4}
                      $marginTop={4}
                      $display="flex"
                      $gap={4}
                      $alignItems="center"
                    >
                      <Condition
                        match={currentCurrency && currentCurrency.logo}
                      >
                        <AddressIcon
                          $iconUrl={currentCurrency && currentCurrency.logo}
                        />
                      </Condition>

                      <BodyTextRegularSecondary color="#AFAFAF">
                        {transaction.address}
                      </BodyTextRegularSecondary>
                    </Box>
                  </Box>
                </Box>
                <Box $textAlign="right">
                  <StyledSum $status={transaction.status}>
                    {formatCurrency(transaction.amountFiat, {
                      currency: user.currency,
                      currencySymbol: user.currencySymbol,
                    })}
                  </StyledSum>
                  <Box $marginBottom={4} />
                  <BodyTextRegularSecondary color="#AFAFAF">
                    {transaction.date}
                  </BodyTextRegularSecondary>
                </Box>
              </PaymentBlock>
            );
          })}
        </Box>
      </Box>
    );
  });
};

export { History };
